import { useState } from "react";
import { Ticket, X } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../lib/store";
import { toast } from "sonner";

export const VoucherBox = ({ voucher, onApply, onRemove }) => {
  const { user } = useAuth();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const apply = async () => {
    if (!code.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/vouchers/validate", { code });
      onApply(data);
      toast.success("Buono applicato");
      setCode("");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Buono non valido");
    } finally { setBusy(false); }
  };

  if (voucher) {
    return (
      <div data-testid="voucher-applied" className="flex items-center justify-between border border-[#C9A227]/40 bg-[#C9A227]/5 rounded-sm px-3 py-2 text-sm">
        <span className="flex items-center gap-2 text-[#C9A227] font-mono-ps"><Ticket size={14} />{voucher.code}</span>
        <button data-testid="voucher-remove" onClick={onRemove} className="text-[#9CA3AF] hover:text-white"><X size={14} /></button>
      </div>
    );
  }

  if (!user) {
    return <p data-testid="voucher-login-hint" className="text-[11px] text-[#9CA3AF]">Hai un buono negozio? Accedi per usarlo.</p>;
  }

  return (
    <div className="flex gap-2">
      <input
        data-testid="voucher-input"
        value={code}
        onChange={(e) => setCode(e.target.value.toUpperCase())}
        placeholder="Codice buono (PS-XXXX-XXXX)"
        className="flex-1 min-w-0 bg-black border border-[#C9A227]/25 focus:border-[#C9A227] rounded-sm px-3 py-2 text-sm text-white font-mono-ps outline-none"
      />
      <button data-testid="voucher-apply" onClick={apply} disabled={busy} className="px-3 py-2 text-xs font-mono-ps uppercase tracking-widest border border-[#C9A227]/50 text-[#C9A227] hover:bg-[#C9A227]/10 rounded-sm transition-colors disabled:opacity-50">
        Applica
      </button>
    </div>
  );
};
